import Vue from 'vue'
import VueSimpleSpinner from 'vue-simple-spinner'
import {Component} from "vue-property-decorator";
import Personalization from "@/components/communications/components/Personalization.vue";
import HttpMixin from "@/mixins/HttpMixin";
import {HTTP} from "@/utils/httpCommonUtil";
interface PostmarkSenderSignature {
  confirmed: boolean;
  domain: string;
  emailAddress: string;
  id: number;
  name: string;
  replyToEmailAddress: string;
  isSelected: boolean;
}

@Component({
  components: {
    Personalization,
    VueSimpleSpinner,
  },
  mixins: [HttpMixin],
})
export default class PostmarkSenderSignaturesCard extends Vue {
  private readonly postmarkBaseUrl = '/api/communication-campaigns/postmarkSenderSignatures';
  private readonly senderSignatureUrl = '/api/communication-campaigns/sender-signature';
  private postmarkSenderSignatures = [] as PostmarkSenderSignature[];
  private expandedParam = false;

  get cardExpanded() {
    return this.expandedParam;
  }
  async mounted() {
    await this.loadSenderSignatures();
  }

  async loadSenderSignatures() {
    try {
      const senderSignatureResponse = (await HTTP.get(this.senderSignatureUrl)) as any;
      let signatureEmails = [] as string[];
      if (senderSignatureResponse && senderSignatureResponse.data.data) {
        signatureEmails = (senderSignatureResponse.data.data).map( (senderSig: any) => { return senderSig.senderEmailAddress }) as string[];
      }
      const postmarkSenderSignatureEmails = await HTTP.get(this.postmarkBaseUrl);
      if (postmarkSenderSignatureEmails) {
        this.postmarkSenderSignatures = postmarkSenderSignatureEmails.data.data.SenderSignatures.map( (sender: any) => {
          let isSelected = false;
          if (signatureEmails) {
            isSelected = signatureEmails.includes(sender.EmailAddress);
          }
          return ({
            confirmed: sender.Confirmed,
            domain: sender.Domain,
            emailAddress: sender.EmailAddress,
            id: sender.ID,
            name: sender.Name,
            replyToEmailAddress: sender.ReplyToEmailAddress,
            isSelected: isSelected
          } as PostmarkSenderSignature);
        });
      }
      await this.removeOldEmails(signatureEmails);
    } catch (e) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'Failed to retrieve sender signatures.'
      });
    }
  }

  async removeOldEmails(signatureEmails: string[]) {
    const postmarkEmails = this.postmarkSenderSignatures.map( (postmark) => { return postmark.emailAddress; }) as string[];
    const emailsToDelete = signatureEmails.filter( (item: string) => postmarkEmails.indexOf(item) === -1);
    const promises = [] as any[];
    for (const email of emailsToDelete) {
      promises.push(HTTP.delete(`${this.senderSignatureUrl}/${email}`));
    }
    await Promise.all(promises);
  }

  async saveEmailAddress(emailAddress: PostmarkSenderSignature) {
    try {
      if (emailAddress.isSelected) {
        await HTTP.post(`${this.senderSignatureUrl}/`, {senderEmailAddress: emailAddress.emailAddress});
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Success',
          text: 'Successfully added email.'
        });
      } else {
        await HTTP.delete(`${this.senderSignatureUrl}/${emailAddress.emailAddress}`);
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Success',
          text: 'Successfully removed email.'
        });
      }
    } catch(err) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'Failed to save email.'
      });
    }
  }

  async expandCard(){
    this.expandedParam = !this.expandedParam;
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/cards/postmark-sender-signatures/PostmarkSenderSignaturesCard.ts